import React from 'react';
import FlowRendererField from 'conversie-flow-bundle/assets/js/components/flow/renderers/FlowRendererField';

/* Conversion Fields */
import ConversionFieldImage from '../fields/ConversionFieldImage';

/* Utilities */
import { trans } from '~/utilities';
import ConversionFieldHeader from "../fields/ConversionFieldHeader";

export default function ConversionComponentTradeproposalImage({ component, path, id, ...passProps }) {
    const { id: componentId, metadata } = component;
    const { title } = metadata;

    return (
        <>
            {(title || component.name !== 'trade-in-vehicle') && (
                <div className="col-12 d-flex justify-content-between align-items-center">
                    {title && (
                        <p className={`flow__header-title flow__header-title--${componentId} mb-0`}>
                            {title}
                        </p>
                    )}
                    {component.name !== 'trade-in-vehicle' && (
                        <p className="text--sm text-muted--40">
                            {trans('app.flow.tradeproposal.image.optional')}
                        </p>
                    )}
                </div>
            )}
            <div className="col-12">
                <div className="row gutters-1">
                    <FlowRendererField
                        component={component}
                        fields={component?.fields}
                        path={`${path}.fields`}
                        id={`${id}.fields`}
                        {...passProps}
                        renderField={(field, props) => {
                            if (field.type === 'header') {
                                return (
                                    <ConversionFieldHeader
                                        {...props}
                                        colExtensionClasses="mt-2"
                                    />
                                )
                            }

                            if (field.type === 'file') {
                                return (
                                    <ConversionFieldImage
                                        {...props}
                                        inputType="file"
                                    />
                                );
                            }
                        }}
                    />
                </div>
            </div>
        </>
    );
}
